import { render, staticRenderFns } from "./PrimaryRepresentative.vue?vue&type=template&id=f073a930&"
import script from "./PrimaryRepresentative.vue?vue&type=script&lang=js&"
export * from "./PrimaryRepresentative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports